import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import StatusCardList from '../StatusCardList';
import Modal from '../shared/Modal';
import UserCard from '../shared/UserCard';
import { PublicUserDto, UserSearchParams } from 'utils/wemble-api.generated';

const Statuses = ({
  users,
  isFetching,
  officeOrGroupSelected,
  filterBar,
  searchParams,
}: {
  users: PublicUserDto[] | undefined;
  isFetching: boolean;
  officeOrGroupSelected: boolean;
  filterBar?: React.ReactNode;
  searchParams?: UserSearchParams;
}) => {
  const [clickedUserId, setClickedUserId] = useState<string | null | undefined>();
  // A group link on the card navigates to /home?group=…: close the card.
  const { search } = useLocation();
  useEffect(() => setClickedUserId(undefined), [search]);

  return (
    <>
      <StatusCardList
        users={users}
        onClick={(user) => {
          setClickedUserId(user._id);
        }}
        isFetching={isFetching}
        officeOrGroupSelected={officeOrGroupSelected}
        filterBar={filterBar}
        searchParams={searchParams}
      />
      <Modal visible={typeof clickedUserId === 'string'} close={() => setClickedUserId(undefined)} closeButton customWidth={1250}>
        {clickedUserId && <UserCard userId={clickedUserId as string} />}
      </Modal>
    </>
  );
};

export default Statuses;
